<template>
  <div class="columns is-multiline">
    <div class="column is-full">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">
            Αναφορά Κερδοφορίας Παραγγελιών (CSV)
          </p>
        </header>

        <div class="card-content">
          <p class="content has-text-grey">
            Εξαγωγή αναλυτικής αναφοράς παραγγελιών σε μορφή CSV. Περιλαμβάνει
            μόνο παραγγελίες με τελευταία κατάσταση
            <strong>Απεστάλη</strong> ή <strong>Παραδόθηκε</strong>. Μέγιστο
            διάστημα: 92 ημέρες.
          </p>

          <ReportDateRange
            :from.sync="from"
            :to.sync="to"
            :preset="activePreset"
            :validation-error="validationError"
            :range-in-days-label="rangeInDaysLabel"
            @preset="onRangePreset"
          />
        </div>

        <footer class="card-footer">
          <div class="card-footer-item">
            <button
              :class="[
                'button',
                'is-primary',
                'is-fullwidth',
                isExporting && 'is-loading',
              ]"
              :disabled="!canExport"
              type="button"
              @click="exportCsv"
            >
              <span class="icon"><i class="fa fa-download"/></span>
              <span>Εξαγωγή CSV</span>
            </button>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import reportDateRange from '@/mixins/reportDateRange';
import ReportDateRange from '@/views/Dashboard/views/Stats/components/ReportDateRange';

export default {
  components: { ReportDateRange },
  mixins: [reportDateRange],

  data() {
    return { isExporting: false };
  },

  methods: {
    onRangePreset(preset) {
      if (preset === 'custom') {
        this.onCustomDateChange();
      } else {
        this.applyPreset(preset);
      }
    },

    async exportCsv() {
      if (!this.canExport) return;
      this.isExporting = true;

      try {
        const response = await request.post(
          '/exports/profitability',
          { from: this.from, to: this.to },
          { responseType: 'blob', handlerEnabled: false },
        );

        const filename =
          this.extractFilename(response) ||
          `merxone_orders_${this.from}_${this.to}.csv`;
        this.downloadBlob(response.data, filename);

        this.$notify({
          type: 'success',
          title: 'Η αναφορά εξήχθη',
          text: `Κατέβηκε το αρχείο ${filename}`,
        });
      } catch (err) {
        console.error(err);
        const status = err && err.response && err.response.status;
        if (status === 401) {
          this.$store.dispatch('logoutUser');
          return;
        }

        const message = await this.extractErrorMessage(err);
        this.$notify({
          type: 'error',
          title: 'Αποτυχία εξαγωγής',
          text: message || 'Το αίτημα απέτυχε. Δοκιμάστε ξανά.',
        });
      } finally {
        this.isExporting = false;
      }
    },

    extractFilename(response) {
      const cd =
        response && response.headers && response.headers['content-disposition'];
      if (!cd) return null;
      const match = /filename="?([^";]+)"?/i.exec(cd);
      return match ? match[1] : null;
    },

    async extractErrorMessage(err) {
      const blob = err && err.response && err.response.data;
      if (!blob || typeof blob.text !== 'function') return null;
      try {
        const text = await blob.text();
        const json = JSON.parse(text);
        if (json.errors)
          return Object.values(json.errors)
            .flat()
            .join(' ');
        return json.message || json.error_message || null;
      } catch (error) {
        return null;
      }
    },

    downloadBlob(blob, filename) {
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: 'text/csv;charset=utf-8' }),
      );
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      link.remove();
    },
  },
};
</script>

<style scoped>
.card-content {
  padding-bottom: 1rem;
}
</style>
